//In caso di utente normale vengono mostrate solo le impostazioni di tipo "project"
//in caso di amministratore vengono mostrate tutte
const scopes = {
	DEVICE: "device",
	DEVICE_PROJECT: "device project",
	DEVICE_PROJECT_TYPE: "device project type",
	DEVICE_TYPE: "device type",
	PROJECT: "project",
	PROJECT_TYPE: "project type",
	TYPE: "type",
	SYSTEM: "system",
}

const groups = {
	agrismart: [
		{
			name: "agrismart-general-notif",
			label: "Notifiche"
		},
		{
			name: "agrismart-general-sensors",
			label: "Sensori"
		},
		{
			name: "agrismart-general-stat",
			label: "Statistiche"
		},
		{
			name: "agrismart-general-irrigation",
			label: "Irrigazione"
		},
		{
			name: "agrismart-general-atm",
			label: "Agenti Atmosferici"
		},
		{
			name: "agrismart-dss",
			label: "DSS"
		},
		{
			name: "agrismart-vite-peronospora",
			label: "Peronospora"
		},
		{
			name: "agrismart-vite-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-vite-botrite",
			label: "Botrite"
		},
		{
			name: "agrismart-olivo-cicloconio",
			label: "Cicloconio o Occhio di Pavone"
		},
		{
			name: "agrismart-melo-ticchiolatura",
			label: "Ticchiolatura"
		},
		{
			name: "agrismart-agrumi-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-grano-septoria",
			label: "Septoria"
		},
		{
			name: "agrismart-grano-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-grano-ruggine-bruna",
			label: "Ruggine Bruna"
		},
		{
			name: "agrismart-grano-ruggine-gialla",
			label: "Ruggine Gialla"
		},
	],

	agrismart2: [
		{
			name: "agrismart-general-notif",
			label: "Notifiche"
		},
		{
			name: "agrismart-general-stat",
			label: "Statistiche"
		},
		{
			name: "agrismart-general-irrigation",
			label: "Irrigazione"
		},
		{
			name: "agrismart-general-atm",
			label: "Agenti Atmosferici"
		},
		{
			name: "agrismart-dss",
			label: "DSS"
		},
		{
			name: "agrismart-vite-peronospora",
			label: "Peronospora"
		},
		{
			name: "agrismart-vite-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-vite-botrite",
			label: "Botrite"
		},
		{
			name: "agrismart-olivo-cicloconio",
			label: "Cicloconio o Occhio di Pavone"
		},
		{
			name: "agrismart-melo-ticchiolatura",
			label: "Ticchiolatura"
		},
		{
			name: "agrismart-agrumi-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-grano-septoria",
			label: "Septoria"
		},
		{
			name: "agrismart-grano-oidio",
			label: "Oidio"
		},
		{
			name: "agrismart-grano-ruggine-bruna",
			label: "Ruggine Bruna"
		},
		{
			name: "agrismart-grano-ruggine-gialla",
			label: "Ruggine Gialla"
		},
	],
}


const itemGroup_notification = [
	{
		name: "notification",
		label: "Invia notifiche",
		description: "",
		type: "text",
		scope: scopes.PROJECT,
		options: [
			{
				name: "Nessuna",
				value: "none"
			},
			{
				name: "Email",
				value: "email"
			},
			{
				name: "SMS",
				value: "sms"
			},
			{
				name: "Email/SMS",
				value: "all"
			},
		]
	},
	{
		name: "pushNotifications",
		label: "Notifiche Push",
		description: "Scegliere se inviare le notifiche sul telefono",
		type: "boolean",
		scope: scopes.PROJECT,
	},
	{
		name: "notif_email",
		label: "Email di contatto",
		description: "Notifiche - L'indirizzo email a cui inviare l'email",
		type: "text",
		scope: scopes.PROJECT,
	},
	{
		name: "notif_sms",
		label: "Telefono di contatto",
		description: "Notifiche - Il numero di telefono a cui inviare l'sms",
		type: "number",
		scope: scopes.PROJECT,
	},
]


const itemGroup_agrismartNotif = [
	...itemGroup_notification,
	{
		name: "battLevelWarn",
		label: "Limite batteria",
		description: "Livello minimo batteria (%)",
		type: "number",
		scope: scopes.PROJECT_TYPE
	},
	{
		name: "dailyMessagesTh",
		label: "Soglia numero messaggi giornalieri",
		description: "Se il numero di messaggi ricevuti è inferiore alla soglia, genera un alert di tipo Connessione",
		type: "number",
		scope: scopes.PROJECT_TYPE
	},
	{
		name: "silencedBattLevel",
		label: "Silenzia notifiche Batteria",
		description: "Notifiche - Se impostato, il sistema non rileverà Livello Batteria fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayBattLevel",
		label: "Ricorrenza notifiche Batteria",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Livello Batteria per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
	{
		name: "silencedConnection",
		label: "Silenzia notifiche Connessione",
		description: "Notifiche - Se impostato, il sistema non rileverà Connessione fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayConnection",
		label: "Ricorrenza notifiche Connessione",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Connessione per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
	{
		name: "silencedSensorFault",
		label: "Silenzia notifiche Sensore Guasto",
		description: "Notifiche - Se impostato, il sistema non rileverà Sensore Guasto fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delaySensorFault",
		label: "Ricorrenza notifiche Sensore Guasto",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Sensore Guasto per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
].map(item => ({ ...item, groupName: "agrismart-general-notif" }))

const itemGroup_agrismartSensors = [
	{
		name: "bigPluvio",
		label: "Pluviometro grande",
		description: "Spuntare la casella se la centralina monta il pluviometro grande",
		type: "boolean",
		scope: scopes.DEVICE,
	},
].map(item => ({ ...item, groupName: "agrismart-general-sensors" }))

const itemGroup_agrismartStat = [
	{
		name: "coldThreshold",
		label: "Soglia ore di freddo",
		description: "Ore di freddo - temperature inferiori verranno conteggiate per il calcolo delle ore di freddo",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "hotThreshold",
		label: "Soglia ore di caldo",
		description: "Ore di caldo - temperature superiori verranno conteggiate per il calcolo delle ore di caldo",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "wetThreshold",
		label: "Soglia ore di bagnatura",
		description: "Ore di bagnatura - valori superiori verranno conteggiati per il calcolo delle ore di bagnatura fogliare",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "lightThreshold",
		label: "Soglia ore di luce",
		description: "Ore di luce - valori di radiazione solare superiori verranno conteggiati per il calcolo delle ore di luce",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "weMinSeparationHours",
		label: "Ore separarazione evento bagnatura",
		description: "Ore separarazione evento bagnatura - ore si minima separazione tra due eventi di bagnatura consecutivi per considerarli distinti",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-general-stat" }))

const itemGroup_agrismartIrrigation = [
	{
		name: "silencedSaturazione",
		label: "Silenzia notifiche Saturazione idrica",
		description: "Notifiche - Se impostato, il sistema non rileverà Saturazione idrica fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "silencedNecessita",
		label: "Silenzia notifiche Necessità idrica",
		description: "Notifiche - Se impostato, il sistema non rileverà Necessità idrica fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delaySaturazione",
		label: "Ricorrenza notifiche Saturazione idrica",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Saturazione idrica per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
	{
		name: "delayNecessita",
		label: "Ricorrenza notifiche Necessità idrica",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Necessità idrica per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "sinonass",
		label: "Soglia Necessità idrica",
		description: "Stress idrico - soglia di necessità idrica (cb)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "siperc",
		label: "Soglia saturazione idrica",
		description: "Stress idrico - soglia di saturazione idrica (cb)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-general-irrigation" }))

const itemGroup_agrismartAtm = [
	{
		name: "silencedGelata",
		label: "Silenzia notifiche Stress Gelata",
		description: "Notifiche - Se impostato, il sistema non rileverà Stress Gelata fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "silencedHighTemperature",
		label: "Silenzia notifiche Stress Caldo",
		description: "Notifiche - Se impostato, il sistema non rileverà Stress Caldo fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayGelata",
		label: "Ricorrenza notifiche Stress Gelata",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Stress Gelata per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
	{
		name: "delayHighTemperature",
		label: "Ricorrenza notifiche Stress Caldo",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Stress Caldo per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "freezeOverLimit",
		label: "Soglia temperatura bulbo secco",
		description: "Stress gelata - soglia di bassa temperatura di bulbo secco (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "freezeOverLimitWB",
		label: "Soglia temperatura bulbo umido",
		description: "Stress gelata - soglia di bassa temperatura di bulbo umido (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "highTemperatureLimit",
		label: "Soglia alta temperatura",
		description: "Stress Caldo - soglia di alta temperatura (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-general-atm" }))

const itemGroup_agrismartDss = [
	{
		name: "silencedPhenologicalAgenda",
		label: "Silenzia notifiche Calendario Fenologico",
		description: "Notifiche - Se impostato, il sistema non rileverà Calendario Fenologico fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayPhenologicalAgenda",
		label: "Ricorrenza notifiche Calendario Fenologico",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Calendario Fenologico per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
	
	{
		name: "silencedPhenological",
		label: "Silenzia notifiche Fase Fenologica",
		description: "Notifiche - Se impostato, il sistema non rileverà Fase Fenologica fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayPhenological",
		label: "Ricorrenza notifiche Fase Fenologica",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Fase Fenologica per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},
].map(item => ({ ...item, groupName: "agrismart-dss" }))

const itemGroup_agrismartVitePeronospora = [
	{
		name: "silencedPeronospora",
		label: "Silenzia notifiche Peronospora",
		description: "Notifiche - Se impostato, il sistema non rileverà Peronospora fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayPeronospora",
		label: "Ricorrenza notifiche Peronospora",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Peronospora per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "pblc",
		label: "Lunghezza germogli > 10 cm",
		description: "Peronospora (infezione primaria) - lunghezza rilevata dei germogli maggiore di 10 cm",
		type: "boolean",
		scope: scopes.DEVICE,
	},
	{
		name: "pmt",
		label: "Temperatura limite",
		description: "Peronospora (infezione primaria) - soglia alta temperatura media giornaliera (°C)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "pmr",
		label: "Piovosità limite",
		description: "Peronospora (infezione primaria) - soglia alta piovosità ultime 48 ore (mm)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "phg",
		label: "Umidità atmosferica alta",
		description: "Peronospora - soglia per umidità atmosferica alta, relativo alla tabella di Goidanich (%)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "pallert",
		label: "Soglia attivazione alert",
		description: "Peronospora (infezione primaria) - soglia di attivazione dell'alert, relativo alla percentuale di avanzamento dell'infezione secondo la tabella di Goidanich (%)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "pht",
		label: "Umidità atmosferica limite",
		description: "Peronospora (infezione secondaria) - soglia alta umidità atmosferica (%)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "pmt2",
		label: "Temperatura limite",
		description: "Peronospora (infezione secondaria) - soglia alta temperatura (°C)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "phtpl",
		label: "Temperatura x ore limite",
		description: "Peronospora (infezione secondaria) - limite temperatura x ore (°C ore)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-vite-peronospora" }))

const itemGroup_agrismartViteOidio = [
	{
		name: "silencedOidio",
		label: "Silenzia notifiche Oidio",
		description: "Notifiche - Se impostato, il sistema non rileverà Oidio fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayOidio",
		label: "Ricorrenza notifiche Oidio",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Oidio per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "oaft",
		label: "Temperatura forma ascofora",
		description: "Oidio - soglia di temperatura per la rilevazione della forma ascofora",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "oafr",
		label: "Piovosità forma ascofora",
		description: "Oidio - soglia di piovosità per la rilevazione della forma ascofora",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ocftmin",
		label: "Temperatura minima forma conidica",
		description: "Oidio - soglia minima di temperatura per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ocftMax",
		label: "Temperatura massima forma conidica",
		description: "Oidio - soglia massima di temperatura per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ocfh",
		label: "Umidità forma conidica",
		description: "Oidio - soglia massima di umidità per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-vite-oidio" }))

const itemGroup_agrismartViteBotrite = [
	{
		name: "silencedBotrite",
		label: "Silenzia notifiche Botrite",
		description: "Notifiche - Se impostato, il sistema non rileverà Botrite fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayBotrite",
		label: "Ricorrenza notifiche Botrite",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Botrite per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "bmt",
		label: "Temperatura media",
		description: "Botrite - soglia massima di temperatura tollerata",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "bwhli",
		label: "Ore di bagnatura limite 1",
		description: "Botrite - soglia massima di ore di bagnatura tollerate (acini integri)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "bwhla",
		label: "Ore di bagnatura limite 2",
		description: "Botrite - soglia massima di ore di bagnatura tollerate (acini lesionati, fase allegagione - invaiatura)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "bwhlm",
		label: "Ore di bagnatura limite 3",
		description: "Botrite - soglia massima di ore di bagnatura tollerate (acini lesionati, fase maturazione)",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "bgs",
		label: "Stato acini",
		description: "Botrite - stato degli acini",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Integro",
				value: "integro"
			},
			{
				name: "Lesionato",
				value: "lesionato"
			},
		]
	},
].map(item => ({ ...item, groupName: "agrismart-vite-botrite" }))

const itemGroup_agrismartOlivoCicloconio = [
	{
		name: "silencedCicloconio",
		label: "Silenzia notifiche Occhio di Pavone",
		description: "Notifiche - Se impostato, il sistema non rileverà Occhio di Pavone fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayCicloconio",
		label: "Ricorrenza notifiche Occhio di Pavone",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Occhio di Pavone per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "cicloconioSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Occhio di Pavone - grado di suscettibilità della cultivar all'infezione occhio di pavone",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "cicloconioTemperatureTL",
		label: "Temperatura minima",
		description: "Occhio di Pavone - soglia minima di temperatura per la rilevazione di Occhio di Pavone (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "cicloconioHumidityTL",
		label: "Umidità minima",
		description: "Occhio di Pavone - soglia minima di umidità per la rilevazione di Occhio di Pavone (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "cicloconioHumidityHoursTL",
		label: "Ore umidità minimo",
		description: "Occhio di Pavone - soglia minima di ore di alta umidità per la rilevazione di Occhio di Pavone (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "cicloconioLeafHumidityTL",
		label: "Bagnatura fogliare minima",
		description: "Occhio di Pavone - soglia minima di bagnatura fogliare per il calcolo del numero di ore di bagnatura (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "cicloconioWettingHoursTL",
		label: "Ore bagnatura minimo",
		description: "Occhio di Pavone - soglia minima di ore di bagnatura consecutive per la rilevazione di Occhio di Pavone (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-olivo-cicloconio" }))

const itemGroup_agrismartMeloTicchiolatura = [
	{
		name: "silencedTicchiolatura",
		label: "Silenzia notifiche Ticchiolatura",
		description: "Notifiche - Se impostato, il sistema non rileverà Ticchiolatura fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayTicchiolatura",
		label: "Ricorrenza notifiche Ticchiolatura",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Ticchiolatura per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "ticchiolaturaSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Ticchiolatura - grado di suscettibilità della cultivar all'infezione da ticchilatura",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "ticchiolaturaRainfallThreshold",
		label: "Piovosità minima",
		description: "Ticchiolatura - soglia minima di piovosità per il calcolo delle ore di bagnatura",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ticchiolaturaLieveGradiOra",
		label: "Limite gradi ora forma lieve",
		description: "Ticchiolatura - valore minimo di gradi ora di bagnatura che determinano un'infezione in forma lieve",
		type: "number",
		scope: scopes.PROJECT_TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "ticchiolaturaMediaGradiOra",
		label: "Limite gradi ora forma media",
		description: "Ticchiolatura - valore minimo di gradi ora di bagnatura che determinano un'infezione in forma media",
		type: "number",
		scope: scopes.PROJECT_TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "ticchiolaturaGraveGradiOra",
		label: "Limite gradi ora forma grave",
		description: "Ticchiolatura - valore minimo di gradi ora di bagnatura che determinano un'infezione in forma grave",
		type: "number",
		scope: scopes.PROJECT_TYPE,
		props: {
			step: 1
		}
	},
	{
		name: "ticchiolaturaMoltiplicatoreFaseFenologica",
		label: "Moltiplicatore fase fenologica",
		description: "Ticchiolatura - moltiplicatore del calcolo dei gradi ora per le fasi fenologiche meno sensibili",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.01
		}
	},
	{
		name: "ticchiolaturaMoltiplicatoreCultivarResistenti",
		label: "Moltiplicatore cultivar resistenti",
		description: "Ticchiolatura - moltiplicatore del calcolo dei gradi ora per le cultivar più resistenti",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.01
		}
	},
	{
		name: "ticchiolaturaMoltiplicatoreCultivarSuscettibili",
		label: "Moltiplicatore cultivar suscettibili",
		description: "Ticchiolatura - moltiplicatore del calcolo dei gradi ora per le cultivar più suscettibili",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.01
		}
	},
].map(item => ({ ...item, groupName: "agrismart-melo-ticchiolatura" }))

const itemGroup_agrismartAgrumiOidio = [
	{
		name: "silencedOidioAgrumi",
		label: "Silenzia notifiche Oidio",
		description: "Notifiche - Se impostato, il sistema non rileverà Oidio fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayOidioAgrumi",
		label: "Ricorrenza notifiche Oidio",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Oidio per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "agrumi-oaft",
		label: "Temperatura forma ascofora",
		description: "Oidio - soglia di temperatura per la rilevazione della forma ascofora",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "agrumi-oafr",
		label: "Piovosità forma ascofora",
		description: "Oidio - soglia di piovosità per la rilevazione della forma ascofora",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "agrumi-ocftmin",
		label: "Temperatura minima forma conidica",
		description: "Oidio - soglia minima di temperatura per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "agrumi-ocftMax",
		label: "Temperatura massima forma conidica",
		description: "Oidio - soglia massima di temperatura per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "agrumi-ocfh",
		label: "Umidità forma conidica",
		description: "Oidio - soglia massima di umidità per la rilevazione della forma conidica",
		type: "number",
		scope: scopes.TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-agrumi-oidio" }))


const itemGroup_agrismartGranoSeptoria = [
	{
		name: "silencedSeptoria",
		label: "Silenzia notifiche Septoria",
		description: "Notifiche - Se impostato, il sistema non rileverà Septoria fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delaySeptoria",
		label: "Ricorrenza notifiche Septoria",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Septoria per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "septoriaSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Septoria - grado di suscettibilità della cultivar all'infezione Septoria",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "septoriaTemperatureThLow",
		label: "Temperatura minima",
		description: "Septoria - soglia minima di temperatura per la rilevazione di Septoria (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "septoriaTemperatureThHigh",
		label: "Temperatura massima",
		description: "Septoria - soglia massima di temperatura per la rilevazione di Septoria (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "septoriaHumidityThLow",
		label: "Umidità minima",
		description: "Septoria - soglia minima di umidità per la rilevazione di Septoria (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "septoriaWettingHoursThLow",
		label: "Ore bagnatura minimo",
		description: "Septoria - soglia minima di ore di bagnatura consecutive per la rilevazione di Septoria (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-grano-septoria" }))

const itemGroup_agrismartGranoOidio = [
	{
		name: "silencedOidioGrano",
		label: "Silenzia notifiche Oidio",
		description: "Notifiche - Se impostato, il sistema non rileverà Oidio fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayOidioGrano",
		label: "Ricorrenza notifiche Oidio",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Oidio per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "oidioGranoSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Oidio - grado di suscettibilità della cultivar all'infezione Oidio",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "oidioGranoTemperatureThLow",
		label: "Temperatura minima",
		description: "Oidio - soglia minima di temperatura per la rilevazione di Oidio (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "oidioGranoTemperatureThHigh",
		label: "Temperatura massima",
		description: "Oidio - soglia massima di temperatura per la rilevazione di Oidio (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "oidioGranoHumidityThLow",
		label: "Umidità minima",
		description: "Oidio - soglia minima di umidità per la rilevazione di Oidio (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "oidioGranoWettingHoursThLow",
		label: "Ore bagnatura minimo",
		description: "Oidio - soglia minima di ore di bagnatura consecutive per la rilevazione di Oidio (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-grano-oidio" }))

const itemGroup_agrismartGranoRuggineBruna = [
	{
		name: "silencedRuggineBruna",
		label: "Silenzia notifiche RuggineBruna",
		description: "Notifiche - Se impostato, il sistema non rileverà Ruggine Bruna fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayRuggineBruna",
		label: "Ricorrenza notifiche Ruggine Bruna",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Ruggine Bruna per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "ruggineBrunaSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Ruggine Bruna - grado di suscettibilità della cultivar all'infezione Ruggine Bruna",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "ruggineBrunaTemperatureThLow",
		label: "Temperatura minima",
		description: "Ruggine Bruna - soglia minima di temperatura per la rilevazione di Ruggine Bruna (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineBrunaTemperatureThHigh",
		label: "Temperatura massima",
		description: "Ruggine Bruna - soglia massima di temperatura per la rilevazione di Ruggine Bruna (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineBrunaHumidityThLow",
		label: "Umidità minima",
		description: "Ruggine Bruna - soglia minima di umidità per la rilevazione di Ruggine Bruna (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineBrunaWettingHoursThLow",
		label: "Ore bagnatura minimo",
		description: "Ruggine Bruna - soglia minima di ore di bagnatura consecutive per la rilevazione di Ruggine Bruna (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-grano-ruggine-bruna" }))

const itemGroup_agrismartGranoRuggineGialla = [
	{
		name: "silencedRuggineGialla",
		label: "Silenzia notifiche Ruggine Gialla",
		description: "Notifiche - Se impostato, il sistema non rileverà Ruggine Gialla fino a quel giorno",
		type: "date",
		scope: scopes.DEVICE_PROJECT,
		deletable: true
	},
	{
		name: "delayRuggineGialla",
		label: "Ricorrenza notifiche Ruggine Gialla",
		description: "Notifiche - In caso di alert aperto, il sistema non rileverà Ruggine Gialla per il numero di giorni specificato",
		type: "number",
		scope: scopes.TYPE,
	},

	{
		name: "ruggineGiallaSusceptibility",
		label: "Suscettibilità cultivar",
		description: "Ruggine Gialla - grado di suscettibilità della cultivar all'infezione Ruggine Gialla",
		scope: scopes.DEVICE,
		props: {
			step: 1
		},
		options: [
			{
				name: "Basso",
				value: "basso"
			},
			{
				name: "Medio",
				value: "medio"
			},
			{
				name: "Alto",
				value: "alto"
			},
		]
	},
	{
		name: "ruggineGiallaTemperatureThLow",
		label: "Temperatura minima",
		description: "Ruggine Gialla - soglia minima di temperatura per la rilevazione di Ruggine Gialla (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineGiallaTemperatureThHigh",
		label: "Temperatura massima",
		description: "Ruggine Gialla - soglia massima di temperatura per la rilevazione di Ruggine Gialla (°C)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineGiallaHumidityThLow",
		label: "Umidità minima",
		description: "Ruggine Gialla - soglia minima di umidità per la rilevazione di Ruggine Gialla (%)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
	{
		name: "ruggineGiallaWettingHoursThLow",
		label: "Ore bagnatura minimo",
		description: "Ruggine Gialla - soglia minima di ore di bagnatura consecutive per la rilevazione di Ruggine Gialla (ore)",
		type: "number",
		scope: scopes.DEVICE_PROJECT_TYPE,
		props: {
			step: 0.1
		}
	},
].map(item => ({ ...item, groupName: "agrismart-grano-ruggine-gialla" }))


const itemGroup_trap = [
	{
		name: "insectDayIncrWrn",
		label: "Soglia warning incremento insetti",
		description: "Valore soglia in conteggi/giorno di warning incremento insetti",
		type: "number",
		scope: scopes.PROJECT_TYPE,
	},
	{
		name: "insectDayIncrAlm",
		label: "Soglia alarm incremento insetti",
		description: "Valore soglia in conteggi/giorno di alarm incremento insetti",
		type: "number",
		scope: scopes.PROJECT_TYPE,
	},
	{
		name: "insectCountFull",
		label: "Max conteggio insetti",
		description: "Valore di massimo conteggio insetti",
		type: "number",
		scope: scopes.PROJECT_TYPE,
	},
]


const settingItems = {

	agrismart: [
		...itemGroup_agrismartNotif,
		...itemGroup_agrismartSensors,
		...itemGroup_agrismartStat,
		...itemGroup_agrismartIrrigation,
		...itemGroup_agrismartAtm,
		...itemGroup_agrismartDss,
		...itemGroup_agrismartVitePeronospora,
		...itemGroup_agrismartViteOidio,
		...itemGroup_agrismartViteBotrite,
		...itemGroup_agrismartOlivoCicloconio,
		...itemGroup_agrismartMeloTicchiolatura,
		...itemGroup_agrismartAgrumiOidio,
		...itemGroup_agrismartGranoSeptoria,
		...itemGroup_agrismartGranoOidio,
		...itemGroup_agrismartGranoRuggineBruna,
		...itemGroup_agrismartGranoRuggineGialla,
	],

	agrismart2: [
		...itemGroup_agrismartNotif,
		...itemGroup_agrismartStat,
		...itemGroup_agrismartIrrigation,
		...itemGroup_agrismartAtm,
		...itemGroup_agrismartDss,
		...itemGroup_agrismartVitePeronospora,
		...itemGroup_agrismartViteOidio,
		...itemGroup_agrismartViteBotrite,
		...itemGroup_agrismartOlivoCicloconio,
		...itemGroup_agrismartMeloTicchiolatura,
		...itemGroup_agrismartAgrumiOidio,
		...itemGroup_agrismartGranoSeptoria,
		...itemGroup_agrismartGranoOidio,
		...itemGroup_agrismartGranoRuggineBruna,
		...itemGroup_agrismartGranoRuggineGialla,
	],

	agrivoltaico: [
		...itemGroup_agrismartNotif,
		...itemGroup_agrismartSensors,
		{
			name: "silencedSaturazione",
			label: "Silenzia notifiche Saturazione idrica",
			description: "Notifiche - Se impostato, il sistema non rileverà Saturazione idrica fino a quel giorno",
			type: "date",
			scope: scopes.TYPE,
			deletable: true
		},
		{
			name: "silencedNecessita",
			label: "Silenzia notifiche Necessità idrica",
			description: "Notifiche - Se impostato, il sistema non rileverà Necessità idrica fino a quel giorno",
			type: "date",
			scope: scopes.TYPE,
			deletable: true
		},
		{
			name: "silencedGelata",
			label: "Silenzia notifiche Stress Gelata",
			description: "Notifiche - Se impostato, il sistema non rileverà Stress Gelata fino a quel giorno",
			type: "date",
			scope: scopes.TYPE,
			deletable: true
		},
		{
			name: "silencedHighTemperature",
			label: "Silenzia notifiche Stress Caldo",
			description: "Notifiche - Se impostato, il sistema non rileverà Stress Caldo fino a quel giorno",
			type: "date",
			scope: scopes.TYPE,
			deletable: true
		},
	],

	badge: [
		{
			name: "shiftLimit",
			label: "Durata turno",
			description: "Limite (in minuti) entro il quale considerare un nuovo passaggio del badge un checkout piuttosto che un nuovo checkin",
			type: "number",
			scope: scopes.TYPE
		},
		{
			name: "withCheckout",
			label: "Con turni",
			description: "Scegliere se classificare le rilevazioni in checkin/checkout",
			type: "boolean",
			scope: scopes.PROJECT
		},
	],

	meteosmart: [
		{
			name: "distanceRef",
			label: "Calibrazione distanza",
			description: "Distanza di riferimento per il calcolo della distanza relativa in cm",
			type: "number",
			scope: scopes.DEVICE,
		},
	],

	radarpest: [
		...itemGroup_notification,
		...itemGroup_trap,
	],

	solarsmart: [
		...itemGroup_notification,

		{
			name: "silencedSolarProduction",
			label: "Silenzia notifiche Produzione Solare",
			description: "Se impostato, il sistema non rileverà alert di tipo Produzione Solare fino a quel giorno",
			type: "date",
			scope: scopes.PROJECT,
			deletable: true
		},
		{
			name: "solarProductionTh00",
			label: "Soglia alert Produzione Solare",
			description: "Valore di soglia in percentaule rispetto al valore atteso di produzione solare PVGIS in riferimento al quale viene generato l'alert Produzione Solare (%)",
			type: "number",
			scope: scopes.PROJECT_TYPE,
			props: {
				min: 10,
				max: 100,
				step: 1
			}
		},
		
		{
			name: "huaweiNorthboundEnable",
			label: "Abilita Huawei API",
			description: "Abilita l'accesso alla API Huawei Northbound",
			type: "boolean",
			scope: scopes.TYPE
		},
		{
			name: "solaredgeV2ApiEnable",
			label: "Abilita Solaredge API v2",
			description: "Abilita l'accesso alla API Solaredge v2",
			type: "boolean",
			scope: scopes.TYPE
		},
		{
			name: "sajESolarEnable",
			label: "Abilita SAJ eSolar",
			description: "Abilita l'accesso a SAJ eSolar",
			type: "boolean",
			scope: scopes.TYPE
		},
		{
			name: "zcsAzzorroEnable",
			label: "Abilita ZCS Azzurro",
			description: "Abilita l'accesso a ZCS Azzurro",
			type: "boolean",
			scope: scopes.TYPE
		},
		{
			name: "foxEssEnable",
			label: "Abilita Fox Ess",
			description: "Abilita l'accesso a Fox Ess",
			type: "boolean",
			scope: scopes.TYPE
		},

		{
			name: "huaweiNorthboundUserName",
			label: "Huawei API - Nome utente",
			description: "Nome utente di accesso alla API Huawei Northbound",
			type: "text",
			scope: scopes.TYPE
		},
		{
			name: "huaweiNorthboundSystemCode",
			label: "Huawei API - Codice accesso",
			description: "Codice di accesso alla API Huawei Northbound",
			type: "text",
			scope: scopes.TYPE
		},
		{
			name: "solaredgeV2AccountKey",
			label: "Solaredge API v2 - Account key",
			description: "Chiave di accesso alla API Solaredge v2",
			type: "string",
			scope: scopes.TYPE
		},
		{
			name: "solaredgeV2ApiKey",
			label: "Solaredge API v2 - API key",
			description: "Chiave di accesso alla API Solaredge v2",
			type: "string",
			scope: scopes.TYPE
		},
		{
			name: "sajESolarUsername",
			label: "SAJ eSolar - Nome utente",
			description: "Nome utente di accesso a SAJ eSolar",
			type: "text",
			scope: scopes.TYPE
		},
		{
			name: "sajESolarPassword",
			label: "SAJ eSolar - Password",
			description: "Password di accesso a SAJ eSolar",
			type: "text",
			scope: scopes.TYPE
		},
		{
			name: "zcsAzzurroApiKey",
			label: "ZCS Azzurro - Chiave di accesso",
			description: "Chiave di accesso ZCS Azzurro",
			type: "string",
			scope: scopes.TYPE
		},
		{
			name: "zcsAzzurroClientCode",
			label: "ZCS Azzurro - Codice cliente",
			description: "Codice cliente ZCS Azzurro",
			type: "string",
			scope: scopes.TYPE
		},
		{
			name: "foxEssApiKey",
			label: "Fox Ess - Chiave di accesso",
			description: "Chiave di accesso alla API Fox Ess",
			type: "string",
			scope: scopes.TYPE
		},
	],

	switch: [
		...itemGroup_notification,
	],

	system: [
		{
			name: "adminEmail",
			label: "Email amministratore",
			description: "Email dell'amministratore del sistema",
			type: "email",
			scope: scopes.SYSTEM
		},
		{
			name: "adminEmailCc",
			label: "Email per conoscenza",
			description: "Email da inserire in cc (separate da virgola)",
			type: "email",
			scope: scopes.SYSTEM
		},
		{
			name: "noreplyEmail",
			label: "Email noreply",
			description: "Email noreply",
			type: "email",
			scope: scopes.SYSTEM
		},
	],

	tracker: [
		...itemGroup_notification,
		{
			name: "battLevel",
			label: "Max Batteria",
			description: "Livello massimo batteria",
			type: "number",
			scope: scopes.TYPE
		},
		{
			name: "delayLimit",
			label: "Delay Limite",
			description: "Delay massimo consentito prima di aggiungere segnalazione",
			type: "number",
			scope: scopes.TYPE
		},
		{
			name: "battLevelWarn",
			label: "Limite batteria",
			description: "Livello minimo batteria (%)",
			type: "number",
			scope: scopes.PROJECT_TYPE
		},

		{
			name: "silencedBattLevel",
			label: "Silenzia notifiche Batteria",
			description: "Notifiche - Se impostato, il sistema non rileverà Battery Low fino a quel giorno",
			type: "date",
			scope: scopes.DEVICE_PROJECT,
			deletable: true
		},
		{
			name: "delayBattLevel",
			label: "Ricorrenza notifiche Batteria",
			description: "Notifiche - In caso di alert aperto, il sistema non rileverà BatteryLow per il numero di giorni specificato",
			type: "number",
			scope: scopes.TYPE,
		},
		{
			name: "silencedGeofencing",
			label: "Silenzia notifiche Geofencing",
			description: "Notifiche - Se impostato, il sistema non rileverà Area In/Out (geofencing) fino a quel giorno",
			type: "date",
			scope: scopes.DEVICE_PROJECT,
			deletable: true
		},
	],

	trapscore: [
		...itemGroup_notification,
		...itemGroup_trap,
	],

}

const Settings = { settingItems, scopes, groups }
export default Settings
